import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { CandidatService } from '../../../../services/candidat.service';
import { MissionService } from '../../../../services/mission.service';
import { EstablishmentService } from '../../../../services/establishment.service';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType } from '../../../../shared/utils/enums';

import { FirstStepAddCandidateComponent } from './first-step-add-candidate/first-step-add-candidate.component';
import { SecondStepAddCandidateComponent } from './second-step-add-candidate/second-step-add-candidate.component';
import { ThirdStepAddCandidateComponent } from './third-step-add-candidate/third-step-add-candidate.component';
import { AddCandidatStepComponent } from './add-candidat-step/add-candidat-step.component';
import { SharedModule } from '../../../../shared/shared.module';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-candidate-dialog',
  standalone: true,
  templateUrl: './add-candidate-dialog.component.html',
  styleUrl: './add-candidate-dialog.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    FirstStepAddCandidateComponent,
    SecondStepAddCandidateComponent,
    ThirdStepAddCandidateComponent,
    AddCandidatStepComponent,
    SharedModule,
    MatStepperModule
  ]
})
export class AddCandidateDialogComponent implements OnInit {
  step = 1;
  loading = false;
  user: any;

  firstStepForm: FormGroup;
  secondStepForm: FormGroup;
  thirdStepForm: FormGroup;
  fourthStepForm: FormGroup;

  isFirstStepValid = false;
  isSecondStepValid = false;
  isThirdStepValid = false;
  isFourthStepValid = false;

  isCurrentStepInvalid = true;
  photoFormData: FormData | null = null;

  @ViewChild(FirstStepAddCandidateComponent) firstStepComponent?: FirstStepAddCandidateComponent;
  @ViewChild(SecondStepAddCandidateComponent) secondStepComponent?: SecondStepAddCandidateComponent;
  @ViewChild(ThirdStepAddCandidateComponent) thirdStepComponent?: ThirdStepAddCandidateComponent;
  @ViewChild(AddCandidatStepComponent) addCandidatStepComponent?: AddCandidatStepComponent;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddCandidateDialogComponent>,
    private candidatService: CandidatService,
    private router: Router,
    private flag: FlagService
  ) {
    this.firstStepForm = this.fb.group({});
    this.secondStepForm = this.fb.group({});
    this.thirdStepForm = this.fb.group({});
    this.fourthStepForm = this.fb.group({
      prefixe: ['MONSIEUR', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      //password: ['', [Validators.required]],
      // confirmBtn: [false, Validators.requiredTrue]
    });
  }

  ngOnInit(): void {}

  back(): void {
    if (this.step > 1) {
      this.step--;
      this.updateCurrentStepInvalid();
    }
  }

  next(id: number): void {
   this.dialogRef.close({});
   this.router.navigate([`/agency/candidates/edit/${id}`]);
  }

  updateCurrentStepInvalid() {
    switch (this.step) {
      case 1:
        this.isCurrentStepInvalid = this.fourthStepForm.invalid;
        break;
      case 2:
        this.isCurrentStepInvalid = this.firstStepForm.invalid;
        break;
      case 3:
        this.isCurrentStepInvalid = this.secondStepForm.invalid;
        break;
      case 4:
        this.isCurrentStepInvalid = this.thirdStepForm.invalid;
        break;
      default:
        this.isCurrentStepInvalid = true;
    }
  }

  onFirstStepValid(isValid: boolean): void {
    setTimeout(() => {
      this.isFirstStepValid = isValid;
      if (this.step === 2) this.isCurrentStepInvalid = !isValid;
    });
  }

  onSecondStepValid(isValid: boolean): void {
    setTimeout(() => {
      this.isSecondStepValid = isValid;
      if (this.step === 3) this.isCurrentStepInvalid = !isValid;
    });
  }

  onThirdStepValid(isValid: boolean): void {
    setTimeout(() => {
      this.isThirdStepValid = isValid;
      if (this.step === 4) this.isCurrentStepInvalid = !isValid;
    });
  }

  onFourthStepValid(isValid: boolean): void {
    // setTimeout(() => {
    //  this.isFourthStepValid = isValid;
    //  if (this.step === 1) this.isCurrentStepInvalid = !isValid;
    // });
    this.dialogRef.close({});
  }

  onPhotoFormData(formData: FormData): void {
    this.photoFormData = formData;
  }

  close(): void {
    this.dialogRef.close();
  }

  private submit(): void {
    this.loading = true;
    const finalBody = {
      ...this.firstStepForm.value,
      ...this.secondStepForm.value,
      ...this.thirdStepForm.value,
      ...this.fourthStepForm.value
    };
    if (finalBody.numtel && typeof finalBody.numtel === 'object') {
      finalBody.numtel = finalBody.numtel.internationalNumber || finalBody.numtel.number || '';
    }

    this.user = localStorage.getItem('temp_user') ? JSON.parse(localStorage.getItem('temp_user') || '') : {};
    
    const body = {
      civility: finalBody.civility,
      lastname: finalBody.lastname,
      firstname: finalBody.firstname,
      fullname: finalBody.lastname + ' ' + finalBody.firstname,
      ishandicap: finalBody.ishandicap,
      handicapsituation: finalBody.handicapsituation,
      isliberal: false,
      birthDay: finalBody.birthDay,
      graduationYear : finalBody.graduationYear,
      mailadress: finalBody.email,
      numsiret: finalBody.numsiret,
      description: finalBody.description,
      socialKey: finalBody.key,
      numsocialsecurity: finalBody.numsocialsecurity,
      numtel: finalBody.numtel,
      typePosteId: finalBody.fonction,
      typeSecteurId: finalBody.worktype,
      adresseCandidatDto: {
        codePostale: finalBody.postalcode,
        additionalAdress: finalBody.adress,
        department: finalBody.departmentName,
        regionName: finalBody.regionName,
        regionCode: finalBody.regionCode,
        pays: finalBody.pays,
        lat: finalBody.lat,
        lon: finalBody.lon,
        ville: finalBody.ville,
      },
      nationality: finalBody.nationality,
    };

    this.candidatService.upadateCandidat(body, this.user?.collary_id).subscribe({
      next: (response) => {
        this.firstStepComponent?.submitPhoto(this.user?.collary_id);
        this.flag.displayFlag('Candidat créé avec succès !', FlagType.success);
        this.dialogRef.close(response);
      },
      error: (error) => {
        this.flag.displayFlag('Erreur lors de la création', FlagType.error, 2);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
